/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { useRetracked } from 'js/lib/retracked';

import { Typography2 } from '@coursera/cds-core';
import { AIGenerateBrandedIcon, CloseIcon } from '@coursera/cds-icons';

import { CoachIconButton } from 'bundles/ai-coach-platform/components/building-blocks';

import _t from 'i18n!nls/unified-common';

const styles = {
  container: css`
    padding: var(--cds-spacing-100) var(--cds-spacing-200);
    display: flex;
    justify-content: space-between;
    align-items: center;
  `,
  brandingContainer: css`
    display: flex;
    align-items: center;
    gap: var(--cds-spacing-50);
  `,
};

const CourseraAIHeader = ({ onClose }: { onClose: () => void }) => {
  const trackRetracked = useRetracked();
  return (
    <div css={styles.container}>
      <div css={styles.brandingContainer}>
        <AIGenerateBrandedIcon />
        <Typography2 component="h2" variant="subtitleSmall">
          {_t('Coursera AI')}
        </Typography2>
      </div>
      <div>
        <CoachIconButton
          size="small"
          icon={<CloseIcon color="default" />}
          aria-label={_t('Close chat')}
          tooltip={_t('Close chat')}
          tooltipPlacement="bottom"
          onClick={() => {
            trackRetracked({
              trackingData: {
                timestamp: Date.now(),
              },
              trackingName: 'ai_course_coach_chat_header_close_button',
              action: `click`,
            });
            onClose();
          }}
          data-testid="coach-close"
        />
      </div>
    </div>
  );
};

export default CourseraAIHeader;
